var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isStaff)?_c('staff'):_vm._e(),(_vm.isTeacher)?_c('teacher'):_vm._e(),(_vm.isStudent)?_c('student'):_vm._e(),(_vm.isParent)?_c('parent'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }